import React from "react";
import "../../Assets/Styles/pages/landing.scss";
import { useTranslation } from "react-i18next";
import { Row } from "react-bootstrap";

const Banner = () => {
  const { t } = useTranslation();

  return (
    <>
      <Row className="m-0 TermsBanner py-5 w-100 d-flex justify-content-center ">
        <Row className=" line_height_100pc text-center py-3 m-0 p-0 d-flex justify-content-center align-items-center text_40 productSansBold">
          <p className="m-0">{t("TermsTitle")}</p>
        </Row>
      </Row>
    </>
  );
};

export default Banner;
